import React from 'react';

// Custom SVG icons — handcrafted, not generic
const CalendarIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square">
    <rect x="3" y="4" width="18" height="18" rx="0" />
    <line x1="3" y1="9" x2="21" y2="9" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="16" y1="2" x2="16" y2="6" />
  </svg>
);

const CardIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square">
    <rect x="2" y="5" width="20" height="14" rx="0" />
    <line x1="2" y1="10" x2="22" y2="10" />
    <line x1="6" y1="15" x2="10" y2="15" />
  </svg>
);

const VehicleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square">
    <path d="M5 17H3a2 2 0 0 1-2-2V9l3-6h14l3 6v6a2 2 0 0 1-2 2h-2" />
    <circle cx="7.5" cy="17.5" r="2.5" />
    <circle cx="16.5" cy="17.5" r="2.5" />
    <line x1="10" y1="17" x2="14" y2="17" />
  </svg>
);

const ShieldIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <polyline points="9 12 11 14 15 10" />
  </svg>
);

const ArrowUpIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="square">
    <line x1="12" y1="19" x2="12" y2="5" />
    <polyline points="5 12 12 5 19 12" />
  </svg>
);

const DocIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="8" y1="13" x2="16" y2="13" />
    <line x1="8" y1="17" x2="12" y2="17" />
  </svg>
);

const SubscriptionStatusCard = ({ subscription, onUpdatePayment, onUpgradePlan }) => {
  const isActive = subscription?.status === 'active';

  return (
    <div style={{ position: 'relative', overflow: 'hidden' }}>
      {/* Main card — dark with diagonal accent */}
      <div style={{
        background: '#111318',
        border: '1px solid rgba(245,166,35,0.15)',
        borderTop: '3px solid #F5A623',
        position: 'relative',
        overflow: 'hidden'
      }}>

        {/* Diagonal background accent */}
        <div style={{
          position: 'absolute',
          top: 0, right: 0,
          width: '40%', height: '100%',
          background: 'linear-gradient(135deg, transparent 0%, rgba(245,166,35,0.04) 100%)',
          clipPath: 'polygon(20% 0, 100% 0, 100% 100%, 0% 100%)'
        }} />

        {/* Ghost watermark — plan name */}
        <div style={{
          position: 'absolute',
          bottom: '-10px', right: '20px',
          fontFamily: 'Impact, Haettenschweiler, sans-serif',
          fontSize: '5rem',
          fontWeight: 900,
          color: 'rgba(245,166,35,0.04)',
          lineHeight: 1,
          userSelect: 'none',
          pointerEvents: 'none',
          letterSpacing: '-0.05em',
          textTransform: 'uppercase'
        }}>PLAN</div>

        {/* Header block */}
        <div style={{
          padding: '28px 36px 24px',
          borderBottom: '1px solid rgba(245,166,35,0.1)',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '20px',
          position: 'relative'
        }}>
          <div>
            {/* Plan name — Impact brutalist */}
            <h2 style={{
              fontFamily: 'Impact, Haettenschweiler, "Arial Narrow", sans-serif',
              fontSize: 'clamp(1.75rem, 3.5vw, 2.75rem)',
              fontWeight: 900,
              color: '#EEF0F2',
              letterSpacing: '-0.02em',
              lineHeight: 0.95,
              textTransform: 'uppercase',
              margin: 0
            }}>{subscription?.planName}</h2>

            {/* Status — inline editorial */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '12px' }}>
              <div style={{
                width: '8px', height: '8px',
                background: isActive ? '#2EC4A0' : '#E85555',
                boxShadow: isActive ? '0 0 0 3px rgba(46,196,160,0.15), 0 0 12px rgba(46,196,160,0.5)' : '0 0 0 3px rgba(232,85,85,0.15)'
              }} />
              <span style={{
                fontFamily: 'Syne, sans-serif',
                fontSize: '0.75rem',
                fontWeight: 700,
                color: isActive ? '#2EC4A0' : '#E85555',
                letterSpacing: '0.12em',
                textTransform: 'uppercase'
              }}>{isActive ? 'Aktivt abonnement' : subscription?.status}</span>
            </div>
          </div>

          {/* Price — polaroid-style block */}
          <div style={{
            background: '#F5A623',
            padding: '16px 20px',
            transform: 'rotate(-1deg)',
            boxShadow: '3px 3px 0 rgba(245,166,35,0.3)',
            textAlign: 'center',
            minWidth: '110px'
          }}>
            <div style={{
              fontFamily: 'Impact, Haettenschweiler, sans-serif',
              fontSize: 'clamp(1.5rem, 3vw, 2.25rem)',
              fontWeight: 900,
              color: '#0A0C10',
              letterSpacing: '-0.03em',
              lineHeight: 1
            }}>{subscription?.monthlyPrice}</div>
            <div style={{
              fontFamily: 'Georgia, serif',
              fontStyle: 'italic',
              fontSize: '0.6875rem',
              color: 'rgba(10,12,16,0.65)',
              marginTop: '3px'
            }}>per måned</div>
          </div>
        </div>

        {/* Body — two column asymmetric */}
        <div style={{
          padding: '28px 36px',
          display: 'grid',
          gridTemplateColumns: '1fr auto',
          gap: '40px',
          alignItems: 'start'
        }}>

          {/* Detail rows — editorial table style */}
          <div>
            {[
              { Icon: CalendarIcon, label: 'Fornyelsesdato', value: subscription?.renewalDate, mono: true, color: '#F5A623' },
              { Icon: CardIcon,     label: 'Betalingsmetode', value: subscription?.paymentMethod, mono: false, color: '#2EC4A0' },
              { Icon: VehicleIcon,  label: 'Kjøretøy inkludert', value: subscription?.vehiclesIncluded, mono: false, color: '#E8A838' },
            ]?.map((item, i) => (
              <div key={i} style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '14px 0',
                borderBottom: i < 2 ? '1px solid rgba(255,255,255,0.04)' : 'none'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{
                    width: '28px', height: '28px',
                    background: `${item?.color}12`,
                    border: `1px solid ${item?.color}25`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    flexShrink: 0,
                    color: item?.color
                  }}>
                    <item.Icon />
                  </div>
                  <span style={{
                    fontFamily: 'Inter, sans-serif',
                    fontSize: '0.875rem',
                    color: '#8A95A3'
                  }}>{item?.label}</span>
                </div>
                <span style={{
                  fontFamily: item?.mono ? 'JetBrains Mono, "Courier New", monospace' : 'Syne, sans-serif',
                  fontSize: item?.mono ? '0.875rem' : '0.9375rem',
                  fontWeight: 600,
                  color: '#EEF0F2',
                  letterSpacing: item?.mono ? '0.04em' : '-0.01em'
                }}>{item?.value}</span>
              </div>
            ))}

            {/* Security strip */}
            <div style={{
              display: 'flex', alignItems: 'center', gap: '8px',
              marginTop: '16px',
              padding: '10px 12px',
              background: 'rgba(46,196,160,0.04)',
              borderLeft: '2px solid rgba(46,196,160,0.3)',
              color: '#8A95A3'
            }}>
              <ShieldIcon />
              <span style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '0.75rem',
                color: '#8A95A3',
                letterSpacing: '0.02em'
              }}>SSL-sikret · 256-bit kryptering · PCI DSS</span>
            </div>
          </div>

          {/* Action buttons — stacked, custom shapes */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', minWidth: '168px' }}>
            <button
              onClick={onUpgradePlan}
              style={{
                background: '#F5A623',
                color: '#0A0C10',
                padding: '13px 20px',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                fontFamily: 'Syne, sans-serif',
                fontSize: '0.75rem',
                fontWeight: 800,
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                boxShadow: '3px 3px 0 rgba(245,166,35,0.25)',
                transition: 'all 150ms cubic-bezier(0.34, 1.56, 0.64, 1)',
                clipPath: 'polygon(0 0, calc(100% - 6px) 0, 100% 6px, 100% 100%, 0 100%)'
              }}
              className="btn-spring btn-aurora"
              onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 0 0 2px rgba(245,166,35,0.4), 4px 4px 0 rgba(245,166,35,0.35), 0 8px 28px rgba(245,166,35,0.3)'; }}
              onMouseLeave={e => { e.currentTarget.style.boxShadow = '3px 3px 0 rgba(245,166,35,0.25)'; }}
            >
              <ArrowUpIcon />
              Oppgrader Plan
            </button>

            {/* Manage subscription button — teal editorial style */}
            <button
              onClick={onUpdatePayment}
              style={{
                background: 'transparent',
                color: '#2EC4A0',
                padding: '12px 20px',
                border: '1px solid rgba(46,196,160,0.35)',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                fontFamily: 'Syne, sans-serif',
                fontSize: '0.75rem',
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                transition: 'all 200ms cubic-bezier(0.34, 1.56, 0.64, 1)',
                width: '100%',
                clipPath: 'polygon(6px 0, 100% 0, 100% calc(100% - 6px), calc(100% - 6px) 100%, 0 100%, 0 6px)'
              }}
              className="btn-spring"
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(46,196,160,0.1)'; e.currentTarget.style.borderColor = 'rgba(46,196,160,0.6)'; e.currentTarget.style.boxShadow = '0 0 0 2px rgba(46,196,160,0.35), 0 8px 24px rgba(46,196,160,0.2)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.borderColor = 'rgba(46,196,160,0.35)'; e.currentTarget.style.boxShadow = 'none'; }}
            >
              <DocIcon />
              Administrer abonnement
            </button>

            {/* Subtle manage payment link */}
            <div style={{
              textAlign: 'center',
              paddingTop: '6px',
              borderTop: '1px solid rgba(255,255,255,0.05)'
            }}>
              <span
                onClick={onUpdatePayment}
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.6875rem',
                  color: 'rgba(245,166,35,0.6)',
                  letterSpacing: '0.04em',
                  cursor: 'pointer',
                  textDecoration: 'none',
                  transition: 'color 150ms ease'
                }}
                className="nav-spring"
                onMouseEnter={e => { e.currentTarget.style.color = '#F5A623'; }}
                onMouseLeave={e => { e.currentTarget.style.color = 'rgba(245,166,35,0.6)'; }}
              >
                Oppdater betalingsmetode →
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionStatusCard;